import classNames from "classnames";
import { Link, NavLink } from "react-router-dom";
import { Icon } from "../icon/icon";
import { SUPPORT_EMAIL_URL, WHATSAPP_URL } from "../../utils/helpers";

const footerNavs = [
  {
    title: "Term of service",
    to: "/legal/terms-of-use",
  },
  {
    title: "Privacy policy",
    to: "/legal/privacy-policy",
  },
  {
    title: "Refund policy",
    to: "/legal/refund-policy",
  },
];

const footerGroups = [
  {
    title: "Company",
    links: [
      // { title: "FAQs", to: "/#faqs" },
      { title: "Blog", to: "/blog", badge: "NEW" },
      // { title: "Roadmap", to: "#", badge: "NEW" },
    ],
  },
  {
    title: "Help",
    links: [
      { title: "Email us", to: SUPPORT_EMAIL_URL },
      { title: "WhatsApp", to: WHATSAPP_URL },
      // { title: "Contact us", to: "/contact" },
      // { title: "Help Center", to: "/help-center" },
    ],
  },
  {
    title: "Legal",
    links: footerNavs,
  },
];

const socialLinks = [
  {
    title: "TikTok",
    icon: "tiktok",
    url: "https://www.tiktok.com/@usetikket",
  },
  {
    title: "Instagram",
    icon: "instagram",
    url: "https://www.instagram.com/usetikket",
  },
  {
    title: "X",
    icon: "twitter",
    url: "https://x.com/usetikket",
  },
];

export const WebsiteFooter = ({
  className = "",
  id = "site-footer",
}: {
  className?: string;
  id?: string;
}) => {
  return (
    <footer
      id={id}
      className={classNames(
        "relative z-[2] overflow-hidden bg-[linear-gradient(180deg,#F4F7FA_4.48%,rgba(213,233,252,0.6)_73.24%)] pb-24 pt-10 md:pb-[420px] md:pt-[100px]",
        className,
      )}
    >
      <div className="max-width-website relative flex flex-col gap-9 md:gap-12">
        <div className="gap-100 flex flex-col justify-between lg:flex-row lg:items-start">
          <div className="flex max-w-[460px] flex-col items-start gap-6">
            <Link to="/" className="block w-[112px]">
              <img
                src="/assets/logo_full.svg"
                className="w-full"
                alt="Tikket"
              />
            </Link>

            <p className="font-onest text-base tracking-[-0.32px] text-[#4f4e4e]">
              Tikket makes every event feel effortless.
            </p>

            <div className="mb-4 flex items-center gap-2 md:mb-0">
              {socialLinks.map((social) => (
                <a
                  key={social.title}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.title}
                  className="flex h-9 w-9 items-center justify-center rounded-[6px] bg-white text-ink transition-all duration-300 hover:-translate-y-0.5 hover:text-blue"
                >
                  <Icon svg={social.icon} width={20} height={20} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:mt-hidden mt-10 flex flex-col gap-8 sm:flex-row sm:gap-[46px]">
            {footerGroups.map((group) => (
              <div
                key={group.title}
                className="flex min-w-[140px] flex-col gap-6"
              >
                <p className="font-onest text-base leading-5 tracking-[-0.32px] text-[#4f4e4e]">
                  {group.title}
                </p>

                <div className="mb-4 flex flex-col items-start gap-5 md:mb-0">
                  {group.links.map((nav) =>
                    nav.to.startsWith("mailto:") ||
                    nav.to.startsWith("http") ||
                    nav.to === "#" ? (
                      <a
                        key={nav.title}
                        href={nav.to}
                        target={nav.to === "#" ? undefined : "_blank"}
                        rel={nav.to === "#" ? undefined : "noreferrer"}
                        className="flex items-center gap-1 font-onest text-base leading-5 tracking-[-0.32px] text-ink transition-colors duration-300 hover:text-blue"
                      >
                        {nav.title}
                        {"badge" in nav && nav.badge ? (
                          <span className="font-onest text-sm font-medium tracking-[-0.28px] text-[#327af3]">
                            {nav.badge}
                          </span>
                        ) : undefined}
                      </a>
                    ) : (
                      <NavLink
                        key={nav.title}
                        to={nav.to}
                        className="flex items-center gap-1 font-onest text-base leading-5 tracking-[-0.32px] text-ink transition-colors duration-300 hover:text-blue"
                      >
                        {nav.title}
                        {"badge" in nav && nav.badge ? (
                          <span className="font-onest text-sm font-medium tracking-[-0.28px] text-[#327af3]">
                            {nav.badge}
                          </span>
                        ) : undefined}
                      </NavLink>
                    ),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="font-onest text-base tracking-[-0.32px] text-[#4f4e4e]">
          © {new Date().getFullYear()} Tikket Ltd.
        </p>
      </div>

      <img
        src="/assets/images/landing-footer-wave.svg"
        alt=""
        aria-hidden
        className="pointer-events-none absolute bottom-[-40px] left-1/2 z-[-2] w-[120vw] max-w-none -translate-x-1/2 opacity-60 md:w-[1458px]"
      />
    </footer>
  );
};
